import "./App.css";
import Home from "./components/Homepages/Home";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Register from "./components/Homepages/Register";
import UserInfo from "./components/Homepages/UserInfo";
import UserIntro from "./components/Homepages/UserIntro";
import Homepage from "./components/Homepages/Homepage";
import NewGrat from "./components/Gratitude/NewGrat";
import EnterGrat from "./components/Gratitude/EnterGrat";
import Gratitude from "./components/Gratitude/Gratitude";
import TodoIntro from "./components/Todo/TodoIntro";
import EnterTodo from "./components/Todo/EnterTodo";
import Todos from "./components/Todo/Todos";
import AffirmIntro from "./components/Affirmations/AffirmIntro";
import Prosperity from "./components/Affirmations/Prosperity";
import Video from "./components/Videos/Video";
import Videos from "./components/Videos/Videos";
import ProsperityDetails from "./components/Affirmations/ProsperityDetails";
import Settings from "./components/Settings";
import { setTheme } from "./reducers/userReducer";
import { useSelector } from "react-redux";

function App() {
  const theme = useSelector(setTheme);
  document.body.style.background = theme.background;
  document.body.style.color = theme.text;

  return (
    <div className="app pb-3">
      <Router>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/register" element={<Register />} />
          <Route path="/user" element={<UserInfo />} />
          <Route path="/userIntro" element={<UserIntro />} />
          <Route path="/home" element={<Homepage />} />
          <Route path="/gratitude" element={<NewGrat />} />
          <Route path="/newGrat" element={<EnterGrat />} />
          <Route path="/gratitudes" element={<Gratitude />} />
          <Route path="/todo" element={<TodoIntro />} />
          <Route path="/enterTodo" element={<EnterTodo />} />
          <Route path="/todos" element={<Todos />} />
          <Route path="/affirmIntro" element={<AffirmIntro />} />
          <Route path="/affirm/prosperity" element={<Prosperity />} />
          <Route path="/affirm/prosperity/details" element={<ProsperityDetails />} />
          <Route path="/video" element={<Video />} />
          <Route path="/video/videos" element={<Videos />} />
          <Route path="/settings" element={<Settings />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
